import { Component, OnInit, HostListener, signal } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UtilisateurService } from '../../services/utilisateur.service';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { KeycloakUtilisateur, UserDtoLight } from 'src/app/bo/user/user';
//import { KeycloakUserSite } from 'src/app/bo/keycloak/keycloakUserSite';
import { TraductionService } from '../../services/traduction.service';

@Component({
  selector: 'app-add-users-to-site-modale',
  templateUrl: './add-users-to-site-modale.component.html',
  styleUrls: ['./add-users-to-site-modale.component.scss'],
  standalone: false
})
export class AddUsersToSiteModaleComponent implements OnInit {

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }
    this.bsModalRef.hide();
  }

  tabUtilisateurs = signal<UserDtoLight[]>([]);
  userSelectionnes = signal<UserDtoLight[]>([]);
  utilisateur: KeycloakUtilisateur;
  erreurRecuperation = signal(false);
  success = signal(false);
  emailSupport: string;
  isUserLogged = signal(false);
  action: string;
  usersList = signal<UserDtoLight[]>([]);

  constructor(public bsModalRef: BsModalRef, private readonly http: HttpService, private readonly fonctionsService: FonctionsService, protected userService: UtilisateurService, private readonly translateService: TraductionService) {}

  ngOnInit():void {
    this.http.get<UserDtoLight[]>('Sites/' + this.userService.currentSite()?.siteId + '/Users').subscribe((users: UserDtoLight[]) => {
      this.userSelectionnes.set(users);
      console.log( this.userSelectionnes() );
    });

    this.http.get<UserDtoLight[]>('Users').subscribe({
      next: (users: UserDtoLight[]) => {
        this.tabUtilisateurs.set(users.filter(u =>  u.enabled === true)
        .sort((a, b) => a.email.localeCompare(b.email)));
      }
    })
  }

  ngOnDestroy() {
  }

  onSubmit() {
    const isDeleteAction = this.action === 'delete';
    const endpoint = isDeleteAction ? 'Sites/DeleteUsers' : 'Sites/AddUsers';
    this.fonctionsService.loading_screen(true);
    const userToAddOrDelete:string[] = this.userSelectionnes().filter(user => 
      isDeleteAction
        ? this.usersList().some(userSite => userSite.userId === user.userId)
        : !this.usersList().some(userSite => userSite.userId === user.userId)
    ).map(user => user.userId);

    if (userToAddOrDelete.length === 0) {
      const messageKey = isDeleteAction 
          ? 'GLOBAL.DELETE_USERS_ERROR_MSG'
          : 'GLOBAL.ADD_USERS_ERROR_MSG';
      const message = this.translateService.instant(messageKey); // Assuming you're using ngx-translate or similar
      this.fonctionsService.launch_toast(false, isDeleteAction, message);
      this.fonctionsService.loading_screen(false);
      return;
  }

    this.http.post(`${endpoint}?siteId=${this.userService.currentSite()?.siteId}`, userToAddOrDelete)
        .subscribe({
            next: () => {
                this.success.set(true);
            },
            error: () => {
                this.success.set(false);
            },
            complete: () => {
                this.fonctionsService.loading_screen(false);
                this.fonctionsService.launch_toast(this.success());
                this.bsModalRef.hide();
            }
        });
  }

  compareFunction(item:UserDtoLight, selected:UserDtoLight) {
    return item.userId === selected.userId;
  }

  showModalCancel() {
    this.bsModalRef.hide();
  }
}
